/**
 * PATH: apps/ai/src/pages/OpenClawConceptsPage.tsx
 * PURPOSE: Concept exploration - 24/7 Proactive AI & Agentic Flows
 * SUB-MODULES: ./openclaw-concepts/
 */

import { useState, useEffect } from 'react'
import { PasswordGate, STORAGE_KEY } from './openclaw-concepts/PasswordGate'
import { HeroSection } from './openclaw-concepts/HeroSection'
import { VisionSection } from './openclaw-concepts/VisionSection'
import { ProactiveFeaturesSection } from './openclaw-concepts/ProactiveFeaturesSection'
import { AgenticFlowsSection } from './openclaw-concepts/AgenticFlowsSection'
import { RoadmapSection, Footer } from './openclaw-concepts/RoadmapSection'

function ConceptsContent() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <HeroSection />
      <VisionSection />
      <ProactiveFeaturesSection />
      <AgenticFlowsSection />
      <RoadmapSection />
      <Footer />
    </div>
  )
}

export default function OpenClawConceptsPage() {
  const [isUnlocked, setIsUnlocked] = useState(false)

  useEffect(() => {
    const isAuth = sessionStorage.getItem(STORAGE_KEY) === 'true'
    setIsUnlocked(isAuth)
  }, [])

  if (!isUnlocked) return <PasswordGate onUnlock={() => setIsUnlocked(true)} />
  return <ConceptsContent />
}
